// An execution that runs in its own pod has no startTime until the pod starts.
// Until then it only has queuedAt.
export const displayStartTime = (execution) =>
  execution.startTime || execution.queuedAt;

export const isQueued = (execution) =>
  !execution.startTime && !execution.endTime;
